<template>
      <b-modal :id="modalID" :ref='modalID' :name="modalID" :title="'Items Needing Attention ('+items.length+' total)'" okOnly ok-title="Close" class size="md">

         <div class="container-fluid p-3 " v-if="items.length > 0">
          <itemAttentionTable/>
        </div>
        <div class="container-fluid p-3 text-center" v-else>
          You have no outstanding items needing attention.
        </div>
    </b-modal>        
</template>

<script>

import itemAttentionTable from "@/pages/users/components/itemAttentionTable";

export default {
  name: 'modalItemsNeedingAttention',
  props: {
    modalID: String
  },
  components: {
    itemAttentionTable
  },
  computed: {
    items () {
        return this.$store.getters.getItems
      },
    userprofile() {
      return this.$store.getters.getProfile;
    },
  },
  methods: {
    gotoRouter(routerlink) {
      this.hideModal()
      this.$router.push(routerlink);
    },
    hideModal(){
      this.$refs[this.modalID].hide()
    },
  },
  beforeMount() {
     try {
          var items = this.$store.getters.getItems
         // window.console.log("Items: " + JSON.stringify(items))
          if(this.$store.getters.getItemsSites.length > 0)
          {
            this.options.push({text: 'Sites', value: '0'})
          }
 
          if(this.$store.getters.getItemsServiceNotifications.length > 0)
          {
            this.options.push({text: 'Notifications', value: '2'})
          }

          if(items.users)
          {
            this.options.push({text: 'Users', value: '3'})
          }
        } catch(error) {
        //    window.console.log("Error occurred!")
            return [];
        }
  },
    data: () => ({
        show: false,
        options: [],
    })
}
</script>